import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Produto } from 'src/app/models/cad/produto/produto';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class ProdutoService extends AbstractIdbaService {

  override model: Produto;

  constructor(http: HttpClient) {
    super(http, new Produto());
    this.programName = "cad/produto/produto.p";
  }

  pesquisarPorCodigo(produtoCod: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-pesquisa-produto-por-codigo";
    request.parameters = { produtoCod };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  listaProduto(param: any) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "cad/produto/produto.p";
    request.procedure = 'pi-filtrar';
    request.parameters = { ...param };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  listaProdutosDespesa() {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-produtos-despesa";
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  pesquisaGrupoTipo() {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-retorna-produtos-grupo-tipo";
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });

  }
}